import { baseApi } from "@/services/api/baseApi";

export const cmsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHomePageContent: builder.query({
      query: () => "home-page-contents",
    }),
    getCourseInfoContent: builder.query({
      query: () => "course-info-page-contents",
    }),
    getUpcomingBatches: builder.query({
      query: () => "batches",
    }),
    getFaqs: builder.query({
      query: ({ type }) => ({
        url: `faqs/?type=${type}`,
      }),
    }),
  }),
});

export const {
  useGetHomePageContentQuery,
  useGetCourseInfoContentQuery,
  useGetUpcomingBatchesQuery,
  useGetFaqsQuery,
} = cmsApi;
